import ScalarSearchInput_vue_vue_type_script_setup_true_lang_default from "./ScalarSearchInput.vue.script.js";
//#region src/components/ScalarSearchInput/ScalarSearchInput.vue
var ScalarSearchInput_default = ScalarSearchInput_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarSearchInput_default as default };

//# sourceMappingURL=ScalarSearchInput.vue.js.map